export const APP_NAME = 'PairFerry';
export const APP_VERSION = '2.2.0';
export const PROTOCOL_VERSION = 2;
export const BLOCK_SIZE = 1024 * 1024;
export const FRAME_SIZE = 32 * 1024;
export const DATA_HIGH_WATER = 4 * 1024 * 1024;
export const DATA_LOW_WATER = 1024 * 1024;
export const MANIFEST_PAGE_SIZE = 128;
export const MAX_SIGNAL_BYTES = 128 * 1024;
export const MAX_DISPLAY_NAME_LENGTH = 40;
export const MAX_BLOCK_RETRIES = 3;
export const ROOM_ID_BYTES = 16;
export const ROOM_SECRET_BYTES = 32;
